const FormikField = {
  sickName: {
    color: '#753cbe',

    fontSize: '14px',
    fontWeight: 'bold',
    margin: 0,
    '@media (min-width: 1024px)': {
      fontSize: '16px'
    }
  },
  label: {
    color: '#707070',

    fontSize: '14x',
    fontWeight: 'bold'
  },
  labelMeal: {
    color: '#a0a0a0',

    fontSize: '12px !important',
    fontWeight: '600'
  },
  MealBtn: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    cursor: 'pointer ',
    height: '32px !important',
    margin: '0 10px !important',
    borderRadius: '16px !important',
    border: 'solid 1px #d8d8d8 !important',
    fontSize: '12px !important',

    backgroundColor: '#f5f5f5 !important'
  },
  markerStyle: {
    top: '50%',
    left: '45px',
    transform: 'translateY(-50%)',
    position: 'absolute',
    fontSize: '14px',
    color: '#707070'
  },
  parentTextField: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center'
  },
  textfied: {
    '& .MuiFormHelperText-root': {
      textAlign: 'left !important'
    },
    input: {
      '&::placeholder': {
        opacity: '1',
        fontSize: '14px',
        color: 'rgba(112, 112, 112, 1)',
        '@media (min-width: 1024px)': {
          fontSize: '18px'
        }
      }
    },
    '& .MuiOutlinedInput-root': {
      boxShadow:
        '4px -4px 15px #FFFFFF, 5px 5px 10px rgba(174, 174, 192, 0.20)',
      fontSize: '0.875rem',
      color: '#753CBE',
      fontFamily: 'dana-bold',
      marginLeft: 'auto',
      height: '48px',
      borderRadius: '16px',
      border: '1px solid #FFFFFF',
      '& > fieldset': {
        border: 'none',
        height: '48px'
      },
      '&:hover': {
        borderColor: '#753CBE'
      },
      '&.Mui-focused': {
        borderColor: '#753CBE',
        borderWidth: '1px'
      },
      '@media (min-width: 1024px)': {
        height: '64px',
        fontSize: '18px',
        boxShadow: '-1px 1px 2px 0px #00000029',
        background: '#ffffff',
        position: 'relative'
      }
    }
  },
  textFieldMarker: {
    zIndex: '10',
    position: 'absolute',
    margin: 'auto',
    width: 'max-content',
    marginLeft: '20px',
    textAlign: 'left',
    fontSize: '14px',
    color: '#707070',
    fontWeight: 400,
    '@media (min-width: 1024px)': {
      fontSize: '18px'
    }
  },
  errorText: {
    color: 'var(--red)',
    fontSize: '12px',
    fontWeight: 'bold',
    marginTop: '6px',
    marginLeft: '8px',
    textAlign: 'left'
  },
  errorTextPhone: {
    position: 'absolute',
    color: '#D81D5D',
    fontWeight: 400,
    fontSize: '12px',
    marginTop: '8px',
    '@media (min-width: 1024px)': {
      fontSize: '18px',
      left: '20px'
    }
  }
};

export default FormikField;
